const i18n = {
  fallbackLocale: "ru",
  
  messages: {
    ru: {
      Yes:  "Да",
      yes:  "да",
      No:   "Нет",
      no:   "нет",
      Data: "Данные",
      URI:  "URI",
      ExportTooMuch1: "Данная выгрузка насчитывает больше результатов, чем может обработать Excel, поэтому показаны первые ",
      exportTooMuch2:  " из них. Используйте фильтры при экспорте, чтобы сократить выгрузку и увидеть нужные вам результаты."
    },
    
    en: {
      Yes:  "Yes",
      yes:  "yes",
      No:   "No",
      no:   "no",
      Data: "Data",
      URI:  "URI",
      ExportTooMuch1: "The export has more results than Excel can handle, so it was reduced for first ",
      exportTooMuch2:  " results. Use columns filtering to reduce your results while exporting."
    },
    
    kz: {
      Yes:  "Иә",
      yes:  "иә",
      No:   "Жоқ",
      no:   "жоқ",
      Data: "Деректер",
      URI: "URI",
      ExportTooMuch1: "Бұл экспортта Excel өңдей алатын нәтижелерден көп нәтиже бар, сондықтан алғашқы ",
      exportTooMuch2:  " көрсетіледі. Жүктеп салуды азайту және қалаған нәтижелерді көру үшін экспорт сүзгілерін пайдаланыңыз."
    }
  }
};

const i18nT = ( id, lang ) => {
  if ( lang && !( lang in i18n.messages ) ) lang = undefined;
  if ( !lang ) lang = i18n.fallbackLocale;

  if ( id ) {
    if ( id in i18n.messages[ lang ] ) return i18n.messages[ lang ][ id ];
    if ( lang != i18n.fallbackLocale && ( id in i18n.messages[ i18n.fallbackLocale ] ) ) return i18n.messages[ i18n.fallbackLocale ][ id ];
  }
  
  return "";
};

/*
module.exports = {
  t: i18nT
};
/**/
/**/
export default {
  t: i18nT
}
/**/
